import { z } from "zod";

const optional = () => z.string().optional().or(z.literal(""));
const optionalNum = () =>
  z
    .union([z.coerce.number(), z.nan(), z.literal("")])
    .optional()
    .transform((v) => (v === "" || v === undefined || Number.isNaN(v as number) ? undefined : Number(v)));

export const machineFormSchema = z
  .object({
    code: z
      .string()
      .trim()
      .min(1, "Code is required")
      .max(20)
      .regex(/^[A-Za-z0-9_-]+$/, "Use letters, numbers, - or _"),
    name: z.string().trim().min(1, "Name is required").max(100),
    process_type_id: z.string().uuid("Process is required"),
    machine_type: z.enum([
      "parter",
      "cold_roll_mill",
      "furnace",
      "skinpass_mill",
      "slitter",
      "tube_mill",
      "ctl",
      "other",
    ]),
    capacity: optional(),
    location_id: optional(),
    status: z.enum(["active", "under_maintenance", "inactive"]),
    min_thickness_mm: optionalNum(),
    max_thickness_mm: optionalNum(),
    max_width_mm: optionalNum(),
    description: optional(),
    sort_order: z.coerce.number().int(),
  })
  .superRefine((v, ctx) => {
    if (
      v.min_thickness_mm != null &&
      v.max_thickness_mm != null &&
      v.min_thickness_mm > v.max_thickness_mm
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Min thickness cannot exceed max",
        path: ["min_thickness_mm"],
      });
    }
  });

export type MachineFormValues = z.infer<typeof machineFormSchema>;

export const emptyMachineForm: MachineFormValues = {
  code: "",
  name: "",
  process_type_id: "",
  machine_type: "parter",
  capacity: "",
  location_id: "",
  status: "active",
  min_thickness_mm: undefined,
  max_thickness_mm: undefined,
  max_width_mm: undefined,
  description: "",
  sort_order: 0,
};
